import { EditedEntryValues } from '../types/approvals-table.types';
import { ApprovalTimeEntry } from '../types/time-tracking-approvals';

/**
 * Overlays a pending inline edit (custom approved hours for invoice and/or bill, approval notes)
 * onto a worklog entry. Returns the entry unchanged — same reference — when it has no pending
 * edit, so callers can run it over every row without churning object identity.
 *
 * Each approved value falls back independently: editing only the bill input leaves the invoice
 * value at its saved figure.
 *
 * `approvalNotes` is checked against `undefined` (not falsy): `null` is a real edit meaning
 * "the user cleared the notes".
 */
export const mergeEditedEntryValues = (
  entry: ApprovalTimeEntry,
  edited: EditedEntryValues | undefined
): ApprovalTimeEntry => {
  if (!edited) return entry;
  return {
    ...entry,
    approvedForInvoiceHours: edited.approvedForInvoiceHours ?? entry.approvedForInvoiceHours,
    approvedForBillHours: edited.approvedForBillHours ?? entry.approvedForBillHours,
    approvalNotes: edited.approvalNotes !== undefined ? edited.approvalNotes : entry.approvalNotes,
  };
};
